import React from 'react';
import styled from 'styled-components';
import I10n from '../features/i10n';
import Toggle from './toggle';

const Container = styled.div`
  display: flex;
  align-items: center;
`;

const InformationWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 10px;
`;

const Title = styled.span`
  font-size: 18px;
  font-weight: 700;
`;

const Description = styled.span`
  font-size: 13px;
  font-weight: 400;
`;

class LicenceSelectorToggle extends React.Component {

  render() {
    const { answer, userAnswers, setAnswer } = this.props;
    const isSelected = userAnswers[answer.criteria] === answer.value;

    return (
      <Container>
        <Toggle
          active={isSelected}
          onToggle={() => {
            const isSelected = userAnswers[answer.criteria] === answer.value;
            if (isSelected) {
              setAnswer(answer.criteria, null);
            } else {
              setAnswer(answer.criteria, answer.value);
            }
          }}
        />
        <InformationWrapper>
          <Title>
            {I10n.getOrDefault(`screen.licence_selector.modal.answer.name.${answer.labelKey}`, answer.name)}
          </Title>
          <Description>
            {I10n.getOrDefault(`screen.licence_selector.modal.answer.hint.${answer.labelKey}`, answer.hint)}
          </Description>
        </InformationWrapper>
      </Container>
    );
  }
}

export default LicenceSelectorToggle;
